import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import FormDelete from '../components/form-delete/form-delete';
import FormCreate from '../components/form-manager/form-manager';
import SearchResult from '../components/search-result/search-result';
import Communication from '../components/communication/communication';
import Header from '../../../components/header/header';

import { searchDepartments, setDefaultPageRules } from '../actions/form-search';

class SettingsDepartment extends Component {
  componentDidMount() {
    const {
      searchDepartments,
      setDefaultPageRules,
    } = this.props;

    setDefaultPageRules();
    searchDepartments({
      page: 1,
      limit: 50,
    });
  }

  render() {
    const {
      userLogged,
    } = this.props;

    return (
      <>
        <Header userLogged={userLogged} />
        <SearchResult />

        <FormDelete />
        <FormCreate />
        <Communication />
      </>
    )
  }
}

const mapStateToProps = ({ authReducer: { authenticated } }) => ({
  userLogged: authenticated,
});

const mapDispatchToProps = dispath => {
  return bindActionCreators({
    searchDepartments,
    setDefaultPageRules,
  }, dispath)
};

export default connect(mapStateToProps, mapDispatchToProps)(SettingsDepartment);
